
import React, {useState, useEffect} from 'react';

import PropTypes from 'prop-types';
import {
    Container,
    Form,
    Row,
    Col,
    Spinner,
    Button,
    Alert,

} from 'react-bootstrap';

import {useDispatch, useSelector} from "react-redux";
import {saveSearchCriteria, reset} from "./searchDataSlice";

import Modal from '../../common/components/Modal';
import './SaveModal.scss';

const SaveModal = (props) => {
    const {
        handleClose,
        title,
        currentFilters,
        exploreMode,
        cubeNamespace,
    } = props;
    const dispatch = useDispatch();
    const searchDataState = useSelector(state => state.searchData);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        // When open dialog, we clear state.

      const resetDialog = () => {
          dispatch(reset());
      };

      resetDialog();
    }, [dispatch]);

    const isValid = () => {
        if (!name) {
            return false;
        }
        return true;
    };

    const isBusy = () => {
        if (searchDataState && searchDataState.status && searchDataState.status.status === 'loading') {
            return true;
        }
        return false;
    };

    const isError = () => {
        if (searchDataState && searchDataState.status && searchDataState.status.status === 'error') {
            return true;
        }
        return false;
    };

    const onClose = () => {
        handleClose();
    };

    if (searchDataState.status.status === 'succeeded') {
        handleClose();
        return (
            <div></div>
        );
    }

    const saveSearch = async (name, description) => {
        const type = exploreMode.mode === 'COMPANY' ? 'SEARCH_COMPANY': 'SEARCH_CONTACT';
        const filters = currentFilters;
        dispatch(saveSearchCriteria({name, type, description, filters, cubeNamespace}));
    };


    return (
        <Modal
            showClose
            size={'lg'}
            title={title}
            handleClose={() => onClose()}
            showHeaderLine
            footer={
                (
                    <div className="footer">

                        <Button
                            variant='info'
                            disabled={isBusy() || !isValid()}
                            onClick={() => saveSearch(name, description)}
                        >
                            {!isBusy() && <>Create</>}
                            {isBusy() && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                        </Button>
                        <Button
                            disabled={isBusy()}
                            variant='outline-secondary'
                            onClick={() => onClose()}
                            style={{marginLeft: '10px'}}
                        >
                            Cancel
                        </Button>
                    </div>
                )
            }
        >
            <Container className="container">
                <Form noValidate>
                    <Form.Group id="saveSearch">
                        <Row>
                            <Col/>
                            <Col>
                                <Form.Label
                                    id={'form-control-name-label-id'}
                                >
                                    Name
                                </Form.Label>
                            </Col>
                            <Col xs={6}>
                                {isError() &&
                                    <Alert
                                        variant={'danger'}
                                        transition={true}
                                    >
                                        An error occurred. Please contact your administrator.
                                    </Alert>
                                }
                                <Form.Control
                                    id={'form-control-name-input-id'}
                                    size="md"
                                    type="input"
                                    name="name"
                                    placeholder="Please enter name."
                                    isInvalid={
                                        !name
                                    }
                                    onChange={(e) => setName(e.target.value)}
                                    data-validate='["required"]'
                                    value={name}
                                />
                                {!name && (
                                    <Form.Control.Feedback
                                        id={'form-control-feed-back-id'}
                                        type="invalid"
                                    >
                                        Name is required.
                                    </Form.Control.Feedback>
                                )}
                            </Col>
                            <Col/>
                        </Row>
                        <Row>
                            <Col/>
                            <Col>
                                <Form.Label
                                    id={'form-control-desc-label-id'}
                                >
                                    Description
                                </Form.Label>
                            </Col>
                            <Col xs={6}>
                                <Form.Control
                                    id={'form-control-desc-text-area-id'}
                                    as={'textarea'}
                                    rows={3}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Col>
                            <Col/>
                        </Row>
                    </Form.Group>

                </Form>
            </Container>

        </Modal>
    );
};

SaveModal.propTypes = {
    title: PropTypes.string,
    exploreMode: PropTypes.object.isRequired,
    currentFilters: PropTypes.array.isRequired,
    cubeNamespace: PropTypes.string,
    handleClose: PropTypes.func,
};

SaveModal.defaultProps = {
    handleClose: (e) => e
};

export default SaveModal;
